import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/col/index.js
// module id = 33
// module chunks = 0